<div *ngIf="!translationsLoading && !validatingAccount; else loading">
  <router-outlet></router-outlet>
</div>
<ng-template #loading>
  <div class="centered-container min-vh-100">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
